import { h, render } from 'preact'; /** @jsx h */
import { useEffect, useState } from 'preact/hooks';
import ShiftCalendarComponent from './components/ShiftCalendarComponent';
import {
    CheckBox,
    Slider,
    GenericDropdown
} from './global/generalComponentsInput';
import { GhostBtn } from './global/generalComponentsButtons';
import { getWidth } from './global/generalVariables';
import { offsetBasedOnWeek } from './global/dateVariables';
import './calendar-page.scss';
import { Provider, useDispatch } from 'react-redux';
import store from './store';
import { optionsLagret } from './reducers/options';

const version = window.calendarpublication;

const generateDataOptions = () => {
    const options = [];
    const today = new Date();
    const currentYear = today.getFullYear();

    // Generate options for past years and current/future years as needed
    // Starting from a base year (e.g., 2023) up to current year + 1
    for (let year = 2023; year <= currentYear + 1; year++) {
        // DK publishes on July 1st
        const dkPublishDate = new Date(year - 1, 6, 1); // Month is 0-indexed, so 6 = July
        if (today >= dkPublishDate || year < currentYear) {
            options.push({
                country: 'DK',
                year: year,
                label: `DK ${year}`
            });
        }

        // NO publishes on November 1st
        const noPublishDate = new Date(year - 1, 10, 1); // Month is 0-indexed, so 10 = November
        if (today >= noPublishDate || year < currentYear) {
            options.push({
                country: 'NO',
                year: year,
                label: `NO ${year}`
            });
        }
    }

    return options;
};
const dataOptions = generateDataOptions();

const MainCalendar = () => {
    const [jsonVakt, setJsonVakt] = useState([]);
    const [intervaler, setLainter] = useState(false);
    const [alleVakter, setAlleVakter] = useState([]);
    const [showMenu, setShowMenu] = useState(false);
    const [showHcm, setShowHcm] = useState(true);
    const [showPilot, setShowPilot] = useState(true);
    const [showLedige, setShowLedige] = useState(false);
    const [sliderView, setSliderView] = useState('NO');
    const [maxShow, setMaxShow] = useState(3);
    const [isLoading, setIsLoading] = useState(false);
    const [selected, setSelected] = useState({
        year: 2023,
        country: 'NO',
        label: 'NO 2023'
    });
    const [grabDataOnce, setGraber] = useState(false);
    const dispatch = useDispatch();

    useEffect(() => {
        doResize();
        if (!grabDataOnce) {
            getDashboardData();
            setGraber(true);
        }

        const resizeListener = () => {
            doResize();
        };
        window.addEventListener('resize', resizeListener);
        // clean up function
        return () => {
            window.removeEventListener('resize', resizeListener);
        };
    }, []);

    useEffect(() => {
        getDashboardData();
    }, [selected]);

    const versionControl = () => {
        if (
            document.scripts['calendarpublication'].attributes['version']
                .value !== version
        ) {
            if (confirm('Det er en ny versjon ute, refresh siden?'))
                window.location.reload();
        }
    };

    useEffect(() => {
        if (!intervaler) {
            setInterval(() => {
                versionControl();
            }, 900000);
            setLainter(true);
        }
    }, []);

    useEffect(() => {
        let newVakter = jsonVakt;

        if (!showHcm) {
            newVakter = jsonVakt.filter((itm) => itm.crewkd != 10);
        }
        if (!showPilot) {
            newVakter = newVakter.filter((itm) => itm.crewkd != 20);
        }
        if (showLedige) {
            newVakter = newVakter.filter((itm) => itm.usid == 0);
        }

        setAlleVakter(newVakter);
    }, [showHcm, showPilot, showLedige]);

    const doResize = () => {
        const innerW = getWidth();
        let wds = innerW / 150;
        wds = parseInt(wds - 1);
        if (wds > 6) wds = 6; //grid doesn't really work with smaller values than 0.1%
        setMaxShow(wds);
    };

    const getDashboardData = async () => {
        setIsLoading(true);
        const res = await fetch(
            `/api/getPublication.php?action=liste_original_${selected.year}_${selected.country}`,
            {
                method: 'post',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );

        const json = await res.json();
        const setV = json.schedule_vakt;
        if (json && setV) {
            setJsonVakt(setV);
            if (json.options) {
                dispatch(optionsLagret(json.options));
            }
            setAlleVakter(setV);
        }
        setIsLoading(false);
    };
    const toggleMenu = () => {
        setShowMenu(!showMenu);
    };
    const changeCountry = (val) => {
        setSliderView(val.toUpperCase());
    };
    const countryVakter = (arr) => {
        return arr.filter((vakt) => vakt.land === sliderView);
    };

    const handleSelected = (item) => {
        const { country, year } = item;
        const label = `${country} ${year}`;
        if (sliderView !== country) {
            setSliderView(country);
        }
        setSelected({ country, year, label });
    };

    return (
        <article
            id="calendar-page-dashboard"
            className={showMenu && !isLoading ? 'menu-shown' : 'hidden-menu'}
        >
            <div className="selected-crew-info">
                <CheckBox
                    id="ledige"
                    name="showledige"
                    label="Kun ledige"
                    checked={showLedige}
                    onChange={setShowLedige}
                />
                <fieldset>
                    <CheckBox
                        id="showHcmCheck"
                        name="showHcmCheck"
                        label="HCM"
                        checked={showHcm}
                        onChange={setShowHcm}
                    />
                    <CheckBox
                        id="showPilotCheck"
                        name="showPilotCheck"
                        label="Pilot"
                        checked={showPilot}
                        onChange={setShowPilot}
                    />
                </fieldset>

                <Slider
                    leftSide="NO"
                    rightSide="DK"
                    value={sliderView}
                    name="slide-calendar-country"
                    changeValue={changeCountry}
                />
                <GenericDropdown
                    label={'Velg publisering'}
                    options={dataOptions}
                    selected={selected}
                    setSelected={handleSelected}
                />
                <GhostBtn
                    label={showMenu ? 'X' : ''}
                    className="close-menupoint"
                    onClick={toggleMenu}
                >
                    {!showMenu && (
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="white"
                            height="30"
                            viewBox="0 0 24 24"
                            width="30"
                        >
                            <path d="M0 0h24v24H0z" fill="none" />
                            <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z" />
                        </svg>
                    )}
                </GhostBtn>
            </div>
            {isLoading ? (
                <p className="loader-container">
                    <div className="loader"></div>
                    Henter publisering: {selected.label}.
                </p>
            ) : (
                <ShiftCalendarComponent
                    vakter={countryVakter(alleVakter)}
                    dobbelvaktSchvid={[]}
                    dobbelpersonSchvid={[]}
                    minFilter
                    ignoreGoTo={true}
                    maxShow={maxShow}
                    filterAllChecked={true}
                    publicDash
                    zoomActive={true}
                    setMaxShow={setMaxShow}
                    offset={offsetBasedOnWeek(1, selected.year)}
                    snapshot
                />
            )}
        </article>
    );
};

render(
    <Provider store={store}>
        <MainCalendar />
    </Provider>,
    document.getElementById('content')
);
